import { render, staticRenderFns } from "./penlin.vue?vue&type=template&id=d217c7c0&scoped=true"
var script = {}
import style0 from "./penlin.vue?vue&type=style&index=0&id=d217c7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d217c7c0",
  null
  
)

export default component.exports